import TeacherLayout from '@/components/teacher/Layout.vue'
import TeacherDetail from '@/components/teacher/Info'
import TextCoursewareList from '@/components/teacher/TextCoursewareList'
import TextCoursewareDetail from '@/components/teacher/TextCoursewareDetail'
import VideoCoursewareList from '@/components/teacher/VideoCoursewareList'
import VideoCoursewareDetail from '@/components/teacher/VideoCoursewareDetail'
import SectionList from '@/components/teacher/sectionList'
import SectionDetail from '@/components/teacher/sectionDetail'
import OrganizationDetail from '@/components/teacher/organizationDetail.vue'
import NoticeList from '@/components/teacher/noticeList.vue'
import NoticeDetail from '@/components/teacher/noticeDetail.vue'
import SchoolDetail from '@/components/teacher/schoolDetail.vue'
import Schoolmate from '@/components/teacher/schoolmate.vue'
import SchoolLife from '@/components/teacher/schoolLife.vue'
import SchoolLifeInfo from '@/components/teacher/schoolLifeInfo.vue'
import SchoolNotic from '@/components/teacher/schoolNotic.vue'
import SchoolCenterNotice from '@/components/teacher/schoolCenterNotice.vue'
import SchoolCenterNoticeInfo from '@/components/teacher/schoolCenterNoticeInfo.vue'
import SchoolMien from '@/components/teacher/schoolMien.vue'

export default {
  path: '/teacher',
  name: 'Teacher',
  component: TeacherLayout,
  redirect: '/teacher/teacherDetail',
  meta: {
    title: '教师详情',
    requireLogin: false
  },
  children: [
    {
      path: 'teacherDetail',
      name: 'TeacherDetail',
      component: TeacherDetail,
      meta: {
        title: '教师详情'
      }
    },
    {
      path: 'organizationDetail',
      name: 'OrganizationDetail',
      component: OrganizationDetail,
      meta: {
        title: '机构详情'
      }
    },
    {
      path: 'textCoursewareList',
      name: 'TextCoursewareList',
      component: TextCoursewareList,
      meta: { title: '文字课件列表' }
    },
    {
      path: 'videoCoursewareList',
      name: 'VideoCoursewareList',
      component: VideoCoursewareList,
      meta: { title: '视频课件列表' }
    },
    {
      path: 'textCoursewareDetail',
      name: 'TextCoursewareDetail',
      component: TextCoursewareDetail,
      meta: { title: '文字课件详情' }
    },
    {
      path: 'videoCoursewareDetail',
      name: 'VideoCoursewareDetail',
      component: VideoCoursewareDetail,
      meta: { title: '视频课件详情' }
    },
    {
      path: 'sectionList',
      name: 'SectionList',
      component: SectionList,
      meta: { title: '课务列表' }
    },
    {
      path: 'sectionDetail',
      name: 'SectionDetail',
      component: SectionDetail,
      meta: { title: '课务详情' }
    },
    {
      path: 'noticeList',
      name: 'NoticeList',
      component: NoticeList,
      meta: { title: '公告列表' }
    },
    {
      path: 'noticeDetail',
      name: 'NoticeDetail',
      component: NoticeDetail,
      meta: { title: '公告详情' }
    },
    {
      path: 'schoolDetail',
      name: 'SchoolDetail',
      component: SchoolDetail,
      meta: { title: '学校详情' }
    },
    {
      path: 'schoolmate',
      name: 'Schoolmate',
      component: Schoolmate,
      meta: { title: '校友中心' }
    },
    {
      path: 'schoolLife',
      name: 'SchoolLife',
      component: SchoolLife,
      meta: { title: '校园生活' }
    },
    {
      path: 'schoolNotic',
      name: 'SchoolNotic',
      component: SchoolNotic,
      meta: { title: '校园公告列表' }
    },
    {
      path: 'schoolLifeInfo',
      name: 'SchoolLifeInfo',
      component: SchoolLifeInfo,
      meta: { title: '校园生活详情' }
    },
    {
      path: 'schoolCenterNotic',
      name: 'SchoolCenterNotice',
      component: SchoolCenterNotice,
      meta: { title: '校园中心公告列表' }
    },
    {
      path: 'schoolCenterNoticeInfo',
      name: 'SchoolCenterNoticeInfo',
      component: SchoolCenterNoticeInfo,
      meta: { title: '校园中心公告详情' }
    },
    {
      path: 'schoolMien',
      name: 'SchoolMien',
      component: SchoolMien,
      meta: { title: '校园风采' }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/teacher.js